<template>
    <div>
        <input type="file"
               id="fileInput"
               class="file-input"
               accept="image/*"
               ref="fileInput"
               @change="handleChange"
               :multiple="multiple">
        <label for="fileInput" class="file-input-label">
            {{fileCount ? `${fileCount} file(s) selected` : 'Select file'}}
        </label>
    </div>
</template>

<script type="text/babel">
import { mapActions } from 'vuex';

/**
 * FileInput component
 * @module FileInput
 * @description Provides hidden file input to be placed in views.
 * @memberOf Component
 */
export default {
    name: 'FileInput',
    data () {
        return {
            fileCount: 0
        };
    },
    props: {
        multiple: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        ...mapActions(['uploadFilesForLayoutAsync', 'getImage']),
        async handleChange (event) {
            const files = event.target.files;
            let filesArray = [];
            for(let i = 0; i < files.length; i++) {
                //check if the file name contains image extension string  and skip invalid files
                if (files[i].name.match(/.(jpg|jpeg|png|gif|webp|svg)$/i)) {
                    filesArray[i] = files[i];
                }
            }
            this.fileCount = filesArray.length;
            this.$refs.fileInput.value = '';
            try {
                let { data } = await this.uploadFilesForLayoutAsync({files: filesArray});
                this.$emit('change', data);
                return data;
            } catch (err) {
                throw new Error(err);
            }
        }
    }
};

</script>

<style lang="scss" scoped>
    .file-input {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
    
    .file-input-label {
        cursor: pointer;
        font-size: 1em;
        font-weight: 600;
        padding: 5px 10px;
        border-radius: 10px;
        color: white;
        @include color('background-color', text-color-light);
        @include color('color', primary);
        display: inline-block;
        &:hover, &:focus {
            @include color('background-color', text-color-light);
            @include color('color', primary-active);
        }
    }
</style>
